<template>
    <div id="primary-footer" class="primary-footer">
        <div class="footer-grid">
            <div class="coll copy">
                <a id="footer-legal" class="footer-head" href="#footer-legal" v-smooth-scroll="{ updateHistory: false }">
                    <fa-icon :icon="['far', 'copyright']" aria-hidden="true"></fa-icon> {{ year }}<br />
                    <span class="legal">TruckDown Info International Inc.</span>
                </a>
            </div>
            <div class="coll footer-links">
                <a class="footer-link" href="/">Search</a>
                <a class="footer-link" href="/route">Routing</a>
                <a class="footer-link" href="/admin">Admin</a>
                <a class="footer-link" href="/settings">My Account</a>
            </div>
            <div class="coll">
                <a id="footer-support" class="footer-head" href="#footer-support" v-smooth-scroll="{ updateHistory: false }">Customer Support</a>
            </div>
            <div class="coll footer-links">
                <a class="footer-link" href="/contact">Contact Us</a>
                <a class="footer-link" href="/contact/feedback">Provide Feedback</a>
                <a v-if="!isPlanRV" class="footer-link" href="/shop/fleets">Fleet & Owner Operators</a>
                <a v-if="!isPlanRV" class="footer-link" href="/shop/advertise">Advertise</a>
                <a v-if="!isPlanRV" class="footer-link" href="/faq">FAQ's</a>
            </div>
            <div v-if="!isPlanRV" class="coll">
                <a id="footer-developer" class="footer-head" href="#footer-developer" v-smooth-scroll="{ updateHistory: false }">Developer</a>
            </div>
            <div v-if="!isPlanRV" class="coll footer-links">
                <a class="footer-link" href="/developers">API Documentation</a>
                <a class="footer-link" href="/developers/reference">API Reference</a>
                <a class="footer-link" href="/search/directory">Search Directory</a>
            </div>
            <div v-if="isPlanRV" class="coll">
                <a id="footer-info" class="footer-head" href="#footer-info" v-smooth-scroll="{ updateHistory: false }">Information</a>
            </div>
            <div v-if="isPlanRV" class="coll footer-links">
                <a class="footer-link" href="/shop/features">For RVs</a>
                <a class="footer-link" href="/shop/advertise">Advertise</a>
            </div>
            <div class="coll">
                <a id="footer-about" class="footer-head" href="#footer-about" v-smooth-scroll="{ updateHistory: false }">About</a>
            </div>
            <div class="coll footer-links">
                <a class="footer-link" href="/terms">Terms of Use</a>
                <a class="footer-link" href="/terms/privacy">Privacy Policy</a>
                <a class="footer-link" href="/about">About Us</a>
                <a v-if="!isPlanRV" class="brand" href="https://www.facebook.com/truckdown" title="Connect with us on facebook." aria-label="Connect with us on facebook.">
                    <fa-icon :icon="['fab', 'facebook']" aria-hidden="true"></fa-icon>
                </a>
                <a v-if="isPlanRV" class="brand" href="https://www.facebook.com/planrv" title="Connect with us on facebook." aria-label="Connect with us on facebook.">
                    <fa-icon :icon="['fab', 'facebook']" aria-hidden="true"></fa-icon>
                </a>
                <a v-if="!isPlanRV" class="brand" href="https://twitter.com/TruckDownInfo" title="Connect with us on twitter." aria-label="Connect with us on twitter.">
                    <fa-icon :icon="['fab', 'twitter']" aria-hidden="true"></fa-icon>
                </a>
            </div>
        </div>
        <div v-if="!isPlanRV" class="footer-content">
            <p class="legal_subtext">Welcome to the TruckDown Info International, Inc. Web site. By using this Web site, you are agreeing to comply with and be bound by its terms of use. Please carefully review the <a href="/terms">Terms of Use Agreement</a>. If you do not agree to these terms, you should not use this Web site in any manner whatsoever.</p>
            <p class="legal_subtext">Since 1997 TruckDown.com has helped commercial trucking fleets locate Vendors throughout the USA and Canada. TruckDown lists Vendor services ranging from Major Truck Repair Facilities, Heavy Duty Towing, Trailer Shops, Truck Stops, A/C to Welding, Truck Friendly Motels, Scales and many other services essential to keeping fleets moving safely and on time.</p>
        </div>
        <div v-if="isPlanRV" class="footer-content">
            <p class="legal_subtext">Welcome to the PlanRV website, operated by TruckDown Info International, Inc. By using this Web site, you are agreeing to comply with and be bound by its terms of use. Please carefully review the <a href="/terms">Terms of Use Agreement</a>. If you do not agree to these terms, you should not use this Web site in any manner whatsoever.</p>
        </div>
    </div>
</template>

<script>
    import script from './primaryFooter';
    export default script;
</script>

<style lang="less" scoped>
    @import "./primaryFooter.less";
</style>
